<template>
  <div>
    <notifications></notifications>
    <navbar :show-navbar="showMenu" type="white" :transparent="false" style="background-color: #ffffff99!important;">
      <div class="navbar-wrapper">
        <div class="navbar-toggle" :class="{ toggled: showMenu }">
          <navbar-toggle-button @click.native="toggleNavbar">
          </navbar-toggle-button>
        </div>
      </div>

      <!--
      <template slot="navbar-menu">
        <a class="nav-link" @click="moveObject">
          <i class="now-ui-icons users_circle-08"></i>
          {{ $t("app.modules.auth_layout.to_access") }}
        </a>
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons location_world"
          :title="$t('app.general.language') + ' | ' + lang"
          :class="'drop-login'"
        >
          <button class="dropdown-item" @click="changeLanguage('es')">
            {{ $t("app.languages.spanish") }}
          </button>
          <button class="dropdown-item" @click="changeLanguage('en')">
            {{ $t("app.languages.english") }}
          </button>
        </drop-down>

      </template>
      -->
    </navbar>
    <div class="wrapper wrapper-full-page">
      <div
        class="full-page section-image"
        :class="pageClass"
        filter-color="black"
      >
        <div class="content">

          <div class="full-page-background content-login" style="backgroundImage: url('img/Background– 4.jpg');">
            <div class="row custom-row" style="height: 100%">
              <!-- LOGIN -->
              <div class="col-6" v-if="isLogin">
                <div class="row custom-row">
                  <div class="col-3"></div>
                  <div class="col-9">
                    <div style="height: 500px"></div>
                    
                    <!--
                    <div>
                      
                      <button class="btn btn-round btn-primary text-uppercase" style="color: white; width: auto;" 
                        @click="switchFroms('login')">
                        {{ $t('app.modules.auth_layout.buttons.request') }}
                      </button>
                    </div>
                    -->
                  </div>
                </div>
              </div>
              <div class="col-6" style="overflow: hidden" v-if="isLogin">
                <div class="block" :class="transitionClass">
                  <login />
                </div>
              </div>
              <!-- REGISTER -->
              <div class="col-8" style="overflow: hidden; top: 70px;" v-if="!isLogin">
                <registro />
              </div>
              <div class="col-4" v-if="!isLogin">
                <div class="row custom-row">
                  <div class="col-3"></div>
                  <div class="col-9">
                    <div style="height: 500px"></div>
                    <div>
                      <button class="btn btn-round btn-primary text-uppercase" style="color: white; width: auto;" 
                        @click="switchFroms('register')">
                        {{ $t('app.modules.auth_layout.buttons.login') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import { mapState, mapMutations } from "vuex";
import Login from "./Login";
import Registro from "./Registro";
import Button from '@/components/Button.vue';

export default {
  components: {
    Registro,
    Navbar,
    NavbarToggleButton,
    Login,
    Button
  },
  computed: {
    ...mapState(["lang"])
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  data() {
    return {
      transitionClass: "show",
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
      isLogin: true
    };
  },
  created() {
    var currentUrl = window.location;
    // console.log(currentUrl);
    if(currentUrl.hash.indexOf("register") > -1){
      this.isLogin = false;
    }
  },
  methods: {
    ...mapMutations({
      setLang: "SET_LANG"
    }),
    changeLanguage(value) {
      this.setLang(value);
      this.$root.$i18n.locale = value;
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
    moveObject() {
      this.transitionClass = this.transitionClass.includes("show") ? "" : "show";
    },
    switchFroms(form) {
      if(form == "login"){
        this.isLogin = false;
        this.$router.push('/register');
      }
      else{
        this.isLogin = true;
        this.$router.push('/login');
      }
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route() {
      this.setPageClass();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
<style scoped>
html {
  max-width: 100%;
  overflow-x: hidden;
}

body {
  background-color: #fafafa;
}

button {
  width: auto !important;
}

.block {
  border-radius: 30px;
  background-color: #cecececc;
  padding: 20px 90px;
  height: 500px;
  width: 500px;
  opacity: 0;
  position: absolute;
  top: 180px;
  left: 100%;
  -webkit-transform: translate(-50%, 0%);
  -moz-transform: translate(-50 0%);
  transform: translate(-50%, 0%);
  -webkit-transition: 1200ms;
  -moz-transition: 1200ms;
  transition: 1200ms;
}

.block.show {
  opacity: 1;
  left: 50%;
}

.content-login {
  position: relative !important;
}

.content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 800px !important;
}

.footer {
  background-color: #1e1e1e;
}

.custom-row {
  margin-right: 0 !important;
}
</style>
